import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Bot } from "lucide-react";

const Index = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen bg-background">
			<div className="container mx-auto px-4 py-16">
				<div className="text-center mb-16">
					<div className="flex justify-center mb-6">
						<div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center">
							<Bot className="w-8 h-8 text-primary-foreground" />
						</div>
					</div>
					<h1 className="text-4xl font-bold mb-4">DSLM</h1>
					<p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
						Deepscan your AI applications and Agents for deployment confidence.
					</p>
					<div className="flex gap-4 justify-center">
						<Button onClick={() => navigate("/auth")} size="lg">
							Get Started
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Index;
